import styled from 'styled-components';

const Divider = styled.div<{ $accent: string }>`
  width: min(46rem, 100%);
  height: 1px;
  margin: 0 auto;
  background:
    linear-gradient(
      90deg,
      rgba(20, 34, 53, 0),
      ${({ $accent }) => $accent},
      rgba(20, 34, 53, 0)
    );
  opacity: 0.55;
`;

type DividerBlockProps = {
  accent: string;
};

export default function DividerBlock({ accent }: DividerBlockProps) {
  return <Divider $accent={accent} aria-hidden="true" />;
}
